export const findSelectionById = (market, selectionId) => market.selections.find((item) => item.id === selectionId);
